import { createBaseDevice } from './shared'

const BOSCH_PROXY_TYPE = /^alarm_bridge_bosch(?:_|$)/

export const boschAdapter = {
  name: 'bosch',
  matches(floorDevice) {
    return BOSCH_PROXY_TYPE.test(floorDevice.device?.type ?? '')
  },
  normalize(floorDevice, context) {
    const baseDevice = createBaseDevice(floorDevice, context)
    const relatedDevice = floorDevice.device?.related_device ?? {}

    return {
      ...baseDevice,
      vendor: 'bosch',
      kind: baseDevice.panel_device_type ?? baseDevice.kind,
      status: relatedDevice.status_text ?? baseDevice.status,
      bypass_text: relatedDevice.bypass_text ?? baseDevice.bypass_text,
    }
  },
}
